import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import { AnimatePresence } from 'framer-motion';

import {
  ModalContainer, ButtonsContainer, Background,
} from './styles';

const Modal = ({
  open, content, labelPrimaryButton, labelSecondaryButton,
  onClickPrimaryButton, onClickSecondaryButton,
  loadingPrimaryButton, loadingLabelPrimaryButton,
}) => {
  const renderModal = () => (
    <>
      <Background
        open={open}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      />
      <ModalContainer
        open={open}
        initial={{
          opacity: 0, y: '100vh', translateX: '-50%', translateY: '-50%',
        }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: '100vh' }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
      >
        {content}
        <ButtonsContainer>
          <Button variant="link" onClick={onClickSecondaryButton}>{labelSecondaryButton}</Button>
          <Button
            onClick={onClickPrimaryButton}
            loading={loadingPrimaryButton}
            loadingLabel={loadingLabelPrimaryButton}
          >
            {labelPrimaryButton}
          </Button>
        </ButtonsContainer>
      </ModalContainer>
    </>
  );

  return (
    <AnimatePresence exitBeforeEnter>
      {open && renderModal()}
    </AnimatePresence>
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.string]).isRequired,
  onClickPrimaryButton: PropTypes.func.isRequired,
  onClickSecondaryButton: PropTypes.func.isRequired,
  labelPrimaryButton: PropTypes.string.isRequired,
  labelSecondaryButton: PropTypes.string.isRequired,
  loadingPrimaryButton: PropTypes.bool,
  loadingLabelPrimaryButton: PropTypes.string,
};

Modal.defaultProps = {
  loadingPrimaryButton: false,
  loadingLabelPrimaryButton: '',
};

export default Modal;
